import { LodgingProviderTypeEnum, PageTypeEnumSelectLodging } from '@/constant';
import { WorkerApplicantSelectors, WorkerFranchiseSelectors } from '@/stores';
import { WorkerRecommenderSelectors } from '@/stores/worker-recommender';
import { convertProviderTableType, NOOP } from '@/utils';

import { ColumnTypes } from '../common/table/type';

export const TriggerSelectLodgingClick = {
	show: NOOP,
};

export const initialValues = {
	providerId: 0,
	providerTable: '',
	searchType: LodgingProviderTypeEnum.ADDRESS,
	searchValue: '',
};

export type TValues = typeof initialValues;

export const getColumns = (): ColumnTypes => [
	{
		title: `ID`,
		dataIndex: 'id',
		key: 'id',
		align: 'center',
		fixed: 'left',
	},

	{
		title: '읍/면',
		dataIndex: 'districtName',
		key: 'districtName',
		align: 'center',
		fixed: 'left',
	},
	{
		title: '숙소 주소',
		dataIndex: 'address',
		key: 'address',
		align: 'center',
		fixed: 'left',
	},

	{
		title: '시설종류',
		dataIndex: 'facilityTypeName',
		key: 'facilityTypeName',
		align: 'center',
		fixed: 'left',
	},
	{
		title: '제공자 구분',
		dataIndex: 'providerTable',
		key: 'providerTable',
		align: 'center',
		fixed: 'left',
		width: 120,
		render: (providerTable: string) =>
			convertProviderTableType(providerTable) || '-',
	},
	{
		title: '제공자',
		dataIndex: 'providerName',
		key: 'providerName',
		align: 'center',
		fixed: 'left',
	},
];

export const selectLodgingModalMap = {
	[PageTypeEnumSelectLodging.FRANCHISE]: {
		selectorParams: WorkerFranchiseSelectors.selectLodgingListParams,
	},
	[PageTypeEnumSelectLodging.RECOMMENDER]: {
		selectorParams: WorkerRecommenderSelectors.selectParamsListsDetail,
	},
	[PageTypeEnumSelectLodging.APPLICANT]: {
		selectorParams: WorkerApplicantSelectors.selectParamsListsDetail,
	},
};
